import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, Subject } from "rxjs";
import { LocationsService } from "../../locations-section/services/Locations.service";
import { MapHelperService } from "src/services/map-helper.service";
import { TurfHelperService } from "src/services/turf-helper.service";
import { FeatureCollection, MultiPolygon, Point, Polygon } from "@turf/helpers";

@Injectable({
  providedIn: "root",
})
export class PanelAddGeofencesService {
  public $guidEditable: string = "";
  public $isDuplicate: boolean = false;
  private isVisibleControlSliderRadio$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private intersectedFeatures$: Subject<any> = new Subject<any>();

  selectedFeatures: FeatureCollection<Polygon | MultiPolygon> = { type: "FeatureCollection", features: [] };

  constructor(private locationService: LocationsService) {
  }

  getVisibleControlSliderRadio(): any {
    return this.isVisibleControlSliderRadio$.asObservable();
  }

  setVisibleControlSliderRadio(resp){
    this.isVisibleControlSliderRadio$.next(resp);
  }
  
  getIntersectedFeatures(): any {
    return this.intersectedFeatures$.asObservable();
  }

  setIntersectedFeatures(resp){
    this.intersectedFeatures$.next(resp);
  }

}
